import MarkerClusterer from "@google/markerclustererplus";

import ReportType from "../../../../enum/ReportType";

import customMarker from "./CustomMarker.js";

const DisplayMarkers = ({
  activeMarkerId,
  closestLocationForTime,
  map,
  pins,
  setActiveMarkerProps,
  setNumUniquePinsOnMap,
  showingHeatMap,
}) => {
  const markers = [];
  const positions = {};
  const heatMapData = [];

  // clear any existing markers or heatmaps on map
  if (map) {
    if (map.markerCluster) {
      map.markerCluster.clearMarkers();
    }
    if (map.userLocationMarker) {
      map.userLocationMarker.setMap(null);
    }
    if (map.heatMap) {
      map.heatMap.setMap(null);
    }
  }

  // no pins to show
  if (pins.length === 0) {
    setNumUniquePinsOnMap(0);
  }

  // pins to show
  pins.forEach((pin, index) => {
    // show heatmap
    if (pin.objType === ReportType.REVENUE) {
      heatMapData.push({
        location: new window.google.maps.LatLng(
          pin.geoPoint.coordinates[1],
          pin.geoPoint.coordinates[0]
        ),
        weight: pin.amount,
      });
    }

    // show pin map
    else {
      const point = {
        id: pin.id,
        color: pin.metadata.displayColor ? pin.metadata.displayColor : "Black",
        lat: pin.geoPoint.coordinates[1],
        lng: pin.geoPoint.coordinates[0],
        marker: pin.marker,
        metadata: pin.metadata,
        objType: pin.objType,
        size: pin.size ? pin.size : "large",
        visible: true,
      };

      const marker = customMarker(point, index, activeMarkerId);

      // pin has already been added to this location
      if (positions[`${marker.position.lat}, ${marker.position.lng}`]) {
        positions[`${marker.position.lat}, ${marker.position.lng}`]++;
      }

      // no pin at this location yet
      else {
        positions[`${marker.position.lat}, ${marker.position.lng}`] = 1;

        // create actual google marker so that it works with clusterer
        const gMarker = new window.google.maps.Marker({
          icon: marker.icon,
          label: marker.label,
          map: map,
          position: marker.position,
        });

        gMarker.addListener("click", () => {
          setActiveMarkerProps(marker);
        });

        setNumUniquePinsOnMap(Object.keys(positions).length);
        markers.push(gMarker);
      }
    }
  });

  // add markers to map, if map is intialized
  if (map) {
    // add new markers
    map.markerCluster = new MarkerClusterer(map, markers, {
      imagePath:
        "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
      maxZoom: 10,
    });

    // if user's location exists, show it on map
    if (closestLocationForTime && closestLocationForTime.geoPoint) {
      const point = {
        id: closestLocationForTime.id,
        color: "Blue",
        lat: closestLocationForTime.geoPoint.coordinates[1],
        lng: closestLocationForTime.geoPoint.coordinates[0],
        marker: "circle",
        metadata: {
          displayColor: "Blue",
          title: closestLocationForTime.createdAt,
        },
        objType: "user-location",
        size: "small",
        visible: true,
      };
      const marker = customMarker(point, 0, activeMarkerId);
      map.userLocationMarker = new window.google.maps.Marker({
        icon: marker.icon,
        label: marker.label,
        map: map,
        position: marker.position,
      });
    }

    // showing heat map
    if (showingHeatMap) {
      map.heatMap = new window.google.maps.visualization.HeatmapLayer({
        data: heatMapData,
        map: map,
      });
    }
  }

  // return nothing
  return null;
};

export default DisplayMarkers;
